/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReceiveAddressVo } from './ReceiveAddressVo';
import {
    ReceiveAddressVoFromJSON,
    ReceiveAddressVoFromJSONTyped,
    ReceiveAddressVoToJSON,
    ReceiveAddressVoToJSONTyped,
} from './ReceiveAddressVo';

/**
 * 
 * @export
 * @interface PageDataReceiveAddressVo
 */
export interface PageDataReceiveAddressVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataReceiveAddressVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataReceiveAddressVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataReceiveAddressVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<ReceiveAddressVo>}
     * @memberof PageDataReceiveAddressVo
     */
    records?: Array<ReceiveAddressVo>;
}

/**
 * Check if a given object implements the PageDataReceiveAddressVo interface.
 */
export function instanceOfPageDataReceiveAddressVo(value: object): value is PageDataReceiveAddressVo {
    return true;
}

export function PageDataReceiveAddressVoFromJSON(json: any): PageDataReceiveAddressVo {
    return PageDataReceiveAddressVoFromJSONTyped(json, false);
}

export function PageDataReceiveAddressVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataReceiveAddressVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(ReceiveAddressVoFromJSON)),
    };
}

export function PageDataReceiveAddressVoToJSON(json: any): PageDataReceiveAddressVo {
    return PageDataReceiveAddressVoToJSONTyped(json, false);
}

export function PageDataReceiveAddressVoToJSONTyped(value?: PageDataReceiveAddressVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(ReceiveAddressVoToJSON)),
    };
}

